<template>
  <img :src="logoSrc" :alt="alt" :class="computedClass" />
</template>

<script>
import { clients } from '@/config/clients';
import { useGlobalStore } from '@/stores/global';

export default {
  name: 'LogoSmall',
  props: {
    alt: {
      type: String,
      default: 'Logo',
    },
    className: {
      type: String,
      default: 'h-9',
    },
  },
  computed: {
    logoSrc() {
      const store = useGlobalStore();
      // Use landingConfig logo_small_url if available and not empty
      if (
        store.landingConfig?.logo_small_url &&
        store.landingConfig.logo_small_url.trim() !== ''
      ) {
        return store.landingConfig.logo_small_url;
      }

      const theme = document.documentElement.getAttribute('data-theme');
      return clients[theme]?.logoSmall;
    },
    computedClass() {
      return this.className;
    },
  },
};
</script>
